module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"keyword":"Keyword","volume":"Volume","position":"Position"},"fr":{"keyword":"Mot clé","volume":"Volume","position":"Position"},"de":{"keyword":"Stichwort","volume":"Volumen","position":"Position"}}')
  delete Component.options._Ctor
}
